import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import { cn } from '../../../utils/cn';

const UserSelector = ({ calendars, selectedUser, onUserSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const selectedCalendar = calendars?.find(cal => cal?.id === selectedUser) || calendars?.[0];

  return (
    <div className="relative">
      <Button
        variant="outline"
        iconName="ChevronDown"
        iconPosition="right"
        onClick={() => setIsOpen(!isOpen)}
        className="min-w-[200px] justify-between"
      >
        <div className="flex items-center space-x-2">
          <div 
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: selectedCalendar?.color }}
          />
          <span>{selectedCalendar?.name}</span>
        </div>
      </Button>
      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown */}
          <div className="absolute top-full left-0 right-0 mt-2 bg-card border border-border rounded-lg shadow-tier-2 z-50 overflow-hidden">
            {calendars?.map(calendar => (
              <div
                key={calendar?.id}
                className={cn(
                  "flex items-center space-x-3 px-4 py-3 cursor-pointer transition-colors",
                  selectedUser === calendar?.id 
                    ? "bg-primary/10 text-primary" :"hover:bg-muted/50"
                )}
                onClick={() => {
                  onUserSelect(calendar?.id);
                  setIsOpen(false);
                }}
              >
                <div 
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: calendar?.color }}
                />
                <div className="flex-1">
                  <p className="font-medium">{calendar?.name}</p>
                  <p className="text-xs text-muted-foreground">
                    {calendar?.isOwn ? 'Edição completa' : 'Apenas visualização'}
                  </p>
                </div>
                {selectedUser === calendar?.id && (
                  <div className="text-primary">✓</div>
                )}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default UserSelector;